<template>
  <div class="list">
    <div class="p-top">
      <div>
        <van-image :src="src" width="149px"></van-image>
      </div>
      <div style="padding-left: 20px">
<!--        <div class="text-r">15 countries in Asia region - 500M/day</div>-->
        <div class="text-r">{{text}}</div>
        <div class="text-b">
          <div class="num" style="display: none">x1</div>
          <div class="cur">{{currencyName}} {{totalAmount}}</div>
        </div>
      </div>
    </div>
    <div class="time">
      <div class="time-l">{{homei18n.start_time}}</div>
      <div class="time-r">{{reserverStartTime}}</div>
    </div>
    <div class="time">
      <div class="time-l">{{homei18n.end_time}}</div>
      <div class="time-r">{{reserverEndTime}}</div>
    </div>
    <div class="use" v-if="packageStatus == 33">
      <div class="use-l33">{{i18nPurchasedPackages.to_be_paid}}</div>
      <div class="use-r" >
        <button @click="toCancel" style="display: none">{{i18nPurchasedPackages.cancel_order}}</button>
        <button @click="toPayment">{{i18nPurchasedPackages.go_to_payment}}</button>
<!--        <button @click="toRecord">Reordering</button>-->
<!--        0-未使用，1-待激活，2-已激活，3-已撤销，4-已退款，9-已结束，33-未支付，88-已取消-->
      </div>
    </div>
    <div class="use" v-if="packageStatus == 3 || packageStatus == 88">
      <div class="use-l88">{{i18nPurchasedPackages.Cancelled}}</div>
      <div class="use-r" >
        <button @click="toRecord">{{i18nPurchasedPackages.Reordering}}</button>
      </div>
    </div>
    <div class="use" v-if="packageStatus == 9">
      <div class="use-l">{{i18nPurchasedPackages.use_completed}}</div>
      <div class="use-r" >
        <button @click="toRecord">{{i18nPurchasedPackages.Reordering}}</button>
      </div>
    </div>
    <div class="use" v-if="packageStatus == 0 || packageStatus == 1">
      <div class="use-l33">{{i18nPurchasedPackages.purchased10}}</div>
      <div class="use-r" >
        <button @click="toRecord">{{i18nPurchasedPackages.Reordering}}</button>
      </div>
    </div>
    <div class="use" v-if="packageStatus == 2">
      <div class="use-l33">{{i18nPurchasedPackages.purchased}}</div>
      <div class="use-r" >
        <button @click="toRecord">{{i18nPurchasedPackages.Reordering}}</button>
      </div>
    </div>
<!--    <div class="use" v-else>-->
<!--      <div class="use-l33">{{i18nPurchasedPackages.purchased}}</div>-->
<!--      <div class="use-r" >-->
<!--        <button @click="toRecord">{{i18nPurchasedPackages.Reordering}}</button>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import { MIFI_CANCEL_ORDER } from '@/apis/cabinet'

export default {
  components: {
  },
  props: {
    src: {
      type: String,
      default: require('../../assets/imgs/img_orderDetail.png')
    },
    text: {
      type: String,
      default: ''
    },
    price: {
      type: String,
      default: ''
    },
    country: {
      type: String,
      default: ''
    },
    currency: {
      type: String,
      default: '$'
    },
    currencyName: {
      type: String,
      default: '$'
    },
    useDay: {
      type: Number || String || undefined,
      default: 0
    },
    width: {
      type: Number || String || undefined,
      default: 3.5
    },
    deposit: {
      type: Number || String,
      default: 0
    },
    totalAmount: {
      type: String,
      default: ''
    },
    reserverStartTime: {
      type: String,
      default: ''
    },
    reserverEndTime: {
      type: String,
      default: ''
    },
    packageUsageTotal: {
      type: String,
      default: ''
    },
    packageStatusTitle: {
      type: String,
      default: ''
    },
    tradeNo: {
      type: String,
      default: ''
    },
    deviceOrderStatus: {
      type: Number,
      default: 0
    },
    productSendSn: {
      type: String,
      default: ''
    },
    packagePrice: {
      type: String,
      default: ''
    },
    orderId: {
      type: String,
      default: ''
    },
    packageStatus: {
      type: String,
      default: ''
    }
  },
  computed: {
    i18n () {
      return this.$t('wifimall')
    },
    homei18n () {
      return this.$t('home')
    },
    i18nPurchasedPackages() {
      return this.$t('purchasedPackages')
    }
  },
  methods: {
    toRecord() {
      this.$router.replace(`/scanOrder?mifiOrderId=${this.tradeNo}`)
    },
    toPayment() {
      this.$router.push({
        path: "/confirm",
        query: { mifiOrderId: this.tradeNo, price: this.packagePrice, payType: 'mifi', currency: this.currency, mifisn: this.productSendS }
        // ?price=1.76&payType=mifi&currency=USD&mifisn=srq311370m5wyrwm&mifiOrderId=CGN202410201421073990826
      })
    },
    toCancel() {
      this.$post(MIFI_CANCEL_ORDER, {
          orderId: this.orderId
        }, res => {
        },
        error => {
          this.$loading(false)
          console.log(error)
        }
      )
    }
  }
}
</script>

<style lang="less" >
.list{
  box-shadow: 0px 6px 10px 1px rgba(0,0,0,0.05);
  border-radius: 18px 18px 18px 18px;
  margin: 20px;
  background: #ffffff;
  padding: 20px;
}
.p-top{
  display: flex;
}
.text-r{
  font-family: MyFont5;
  font-weight: 500;
  font-size: 30px;
}
.text-b{
  margin-top: 60px;
  display: flex;
}
.num{
  font-family: MyFont2;
  font-weight: 400;
  font-size: 23px;
  color: #999999;
}
.cur{
  text-align: right;
  width: 100%;
  font-family: MyFont3;
  font-weight: bold;
  font-size: 36px;
  color: #FF1919;
  margin-top: -7px;
}
.time-l{
  font-family: MyFont2;
  font-weight: 400;
  font-size: 28px;
  color: #999999;
  width: 40%;
}
.time-r{
  font-family: MyFont2;
  font-weight: bold;
  font-size: 28px;
  color: #333333;
  width: 60%;
  text-align: right;
}
.time{
  margin: 18px 0 4px 0;
  display: flex;
}
.use{
  display: flex;
  padding: 20px 0 20px 0;
}
.use-l{
  font-family: MyFont2;
  font-weight: 400;
  font-size: 22px;
  color: #666666;
  width: 30%;
}
.use-l33{
  font-family: MyFont2;
  font-weight: 400;
  font-size: 22px;
  color: #1EBE86 ;
  width: 30%;
}
.use-l88{
  font-family: MyFont2;
  font-weight: 400;
  font-size: 22px;
  color: #FF1919 ;
  width: 30%;
}
.use-r{
  width: 70%;
  text-align: right;
  button{
    font-family: MyFont2;
    font-weight: 400;
    font-size: 22px;
    color: #1EBE86;
    line-height: 0px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    width: 200px;
    height: 60px;
    background: #FFFFFF;
    border-radius: 40px 40px 40px 40px;
    border: 2px solid #1EBE86;
    margin-left: 10px;
  }
}
</style>
